import PropTypes from 'prop-types';

export const studentPropTypes = PropTypes.shape({
    firstName: PropTypes.string,
    id: PropTypes.number,
    isNew: PropTypes.bool,
    lastName: PropTypes.string,
});

export const studentsPropTypes = PropTypes.arrayOf(studentPropTypes);
